import React from 'react';

import { type TTemplate } from '@wp-block-builder/package';

import { RootWaypointRendererProvider } from '../WaypointRendererStore';

import { Provider } from './context';

export { default as useDocumentColors } from './useDocumentColors';

type Props = {
  configuration: TTemplate;
  layoutConfiguration?: TTemplate | null;

  footerBody?: JSX.Element | null;

  children: JSX.Element | JSX.Element[];

  skipLiquid: boolean;
  variables: Record<string, unknown>;
};

export function WaypointDocumentStoreProvider({
  children,
  variables,
  skipLiquid,
  configuration,
  layoutConfiguration,
  footerBody,
}: Props) {
  return (
    <Provider
      footerBody={footerBody ?? null}
      configuration={configuration}
      layoutConfiguration={layoutConfiguration ?? null}
    >
      <RootWaypointRendererProvider
        variables={variables}
        strictVariablesRendering={configuration.strictVariablesRendering}
        skipLiquid={skipLiquid ?? false}
      >
        {children}
      </RootWaypointRendererProvider>
    </Provider>
  );
}
